// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-heredado[data-v-acdbc7e0] {\n  background-color: #fff4ba;\n}\n.disabled-nivel[data-v-acdbc7e0] {\n  opacity: 0.4;\n}", ""]);
// Exports
module.exports = exports;
